<template>
    <div class="page">
        <!-- head -->
        <public-head title="热门专业"></public-head>
        <div v-if="majorList.length>0">
            <div class="major-list">
                <div v-for="(item,index) in majorList" :key="index">
                    <div class="major-item">
                        <div class="major-name">
                            {{item.name}}
                            <div class="arrow"></div>
                        </div>
                        <div class="school" @click="goopenSchool(item)">开设院校</div>
                        <div class="major-info">
                            <div class="info-item">
                                <img
                                    class="icon"
                                    src="https://new.schoolpi.net/attach/small_program/class/host.png"
                                />
                                <div class="info-detail">
                                    <div class="info-value">{{item.sort}}</div>
                                    <div class="info-title">热门排行</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <img
                                    class="icon"
                                    src="https://new.schoolpi.net/attach/small_program/class/clock.png"
                                />
                                <div class="info-detail">
                                    <div class="info-value">{{item.study_years}}</div>
                                    <div class="info-title">修学年限</div>
                                </div>
                            </div>
                            <div class="info-item">
                                <img
                                    class="icon"
                                    src="https://new.schoolpi.net/attach/small_program/class/money.png"
                                />
                                <div class="info-detail">
                                    <div class="info-value">{{item.wages}}</div>
                                    <div class="info-title">平均起薪</div>
                                </div>
                            </div>
                        </div>

                        <div class="pay-hint-content isShow==index?'unellipsis':'ellipsis'">
                            {{item.professional_introduction}}
                            <!-- <div
                                class="position"
                                @click="choose(item,index)"
                                v-if="item.show"
                            >...展开全部</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="_noPost">
            <img
                src="https://new.schoolpi.net/attach/small_program/index/no-data.png"
                class="no-data"
            />
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data() {
        return {
            majorList: [],
            page: 1,
            ellipsis: true,
            show: "",
            isShow: -1
        };
    },
    created() {},
    methods: {
        // 进入相关学校
        goopenSchool(e) {
            var cid = e.cid;
            this.$router.push({
                path: "/fenlei/openSchool",
                query: {
                    cid: cid
                }
            });
        },
        // 点击展开
        choose(e, i) {
          
        },
        //获取热门专业数据
        fetchspecialty() {
            httpPost("/classifie/career_list", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
               
                if (res.code === 1) {
                    res.list.map(item => {
                        item.show = true;
                    });
                    this.majorList = res.list;
                }
            });
        }
    },
    mounted() {
        this.fetchspecialty();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.page {
    background: #f2f2f2;
}
.major-list {
    margin-top: 46px;
}
.major-item {
    padding: 0 0.9375rem;
    background: #fff;
    margin-bottom: 0.625rem;
    position: relative;
}
.major-name {
    padding: 0.9375rem 0 0.625rem 0;
    border-bottom: solid 1rpx #cccccc;
    font-size: 1.0625rem;
    font-weight: bold;
    position: relative;
}
.school {
    position: absolute;
    top: 0.875rem;
    right: 1.875rem;
    font-size: 0.9375rem;
    font-weight: 300;
}
.major-info {
    display: flex;
    justify-content: space-between;
    padding: 0.625rem 0;
}
.info-item {
    display: flex;
}
.arrow {
    position: absolute;
    right: 0.375rem;
    top: 0.3125rem;
    bottom: 0;
    margin: auto 0;
    width: 0.4375rem;
    height: 0.4375rem;
    border-top: 0.1875rem solid rgb(192, 188, 188);
    border-right: 0.1875rem solid rgb(192, 188, 188);
    transform: rotate(45deg);
}
.icon {
    width: 1.5625rem;
    height: 1.5625rem;
    margin: auto 0.625rem auto 0;
    border-radius: 50%;
}

.info-value {
    font-size: 1rem;
    font-weight: 500;
}
.info-title {
    font-size: 0.625rem;
    color: #a9a9a9;
}
/* ****** */
.pay-hint-content {
    font-size: 0.875rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    /* padding-bottom: 20rpx; */
    position: relative;
}
.ellipsis {
    -webkit-line-clamp: 3;
}
.unellipsis {
    -webkit-line-clamp: 0;
}
.position {
    width: 5.125rem;
    position: absolute;
    bottom: 0;
    right: 0.3125rem;
    background: #fff;
    text-align: center;
    font-size: 0.875rem;
    /* color:  */
    /* box-shadow: 100rpx 10rpx 50rpx 0 #fff; */
}
/* ****** */
._noPost {
    text-align: center;
    position: relative;
}
.no-data {
    width: 6.25rem;
    height: 6.25rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}
</style>